import { useContext } from "react";
import TableHeader from "./TableHeader"
import { TableBody } from "./TableBody"
import { Context } from "./Context";

function Table({ columns, upTrend, mobile }) {
    const { updateSortKey, contextData, updateRefresh } = useContext(Context)
    const rows = contextData.rows

    const handleSorting = (sortField, sortOrder) => {
        updateSortKey({ 'sortField': sortField, 'sortOrder': sortOrder });
    };

    return (
        <table className="table table-rounded stickyHead">
            <TableHeader columns={columns} onSort={handleSorting} upTrend={upTrend} />
            <TableBody rows={rows} updateRefresh={updateRefresh} upTrend={upTrend} mobile={mobile} />
        </table>
    )
}

export default Table